<template>
  <div class="menu">
    <div class="header-banner">
      <BannerOne title="Payment Method" />

      <div class="container">
        <div class="loading" v-if="paymentprocess">
          Please Wait, Processing Payment.
        </div>
      </div>

      <div class="container" v-if="!paymentprocess">
        <div class="amount">Your Cart Total</div>
        <div class="amount-text">NRs. {{ this.amount }} /-</div>

        <div class="cartid-text">
          Order ID:
          <div class="id-text">#{{ this.cartid }}</div>
        </div>

        <div class="sub-header">Pay Now Via</div>
        <div class="custom-button-wrap">
          <div class="custom-button black" @click="handleIMETokenGeneration()">
            <img
              src="../../assets/imepaylogo.svg"
              class="client_image"
              alt="Card"
            />
          </div>
          <div class="custom-button black" @click="handleEsewaPayment()">
            <img
              src="../../assets/images/esewa_logo_black.png"
              class="client_image"
              alt="Esewa"
            />
          </div>

          <div class="custom-button black" @click="startFonepayPayment()">
            <img
              src="../../assets/images/fonepay_logo.jpg"
              class="client_image"
              alt="Card"
            />
          </div>

          <div class="custom-button black" @click="showModal">
            <img
              src="../../assets/images/card-payment.jpg"
              class="client_image"
              alt="Card"
            />
          </div>
        </div>
      </div>
    </div>
    <modal
      v-show="isModalVisible"
      @close="closeModal"
      @phone="userPhone"
      @email="userEmail"
    />
  </div>
</template>

<script>
// @ is an alias to /src\

import BannerOne from "../../components/BannerOne.vue";
import { CartData } from "../../services/storage.service";
import axios from "axios";
import Modal from "../../components/Modal";
import { format } from "date-fns";
import router from "../../router";

export default {
  name: "ExternalPayment",
  components: {
    BannerOne,
    Modal,
  },
  data() {
    return {
      isModalVisible: false,
      email: "",
      number: "",
      paymentprocess: false,
      amount: JSON.stringify(CartData.getExtCartAmount()),
      cartid: JSON.stringify(CartData.getExtCartId()),
    };
  },

  methods: {
    userPhone: function (value) {
      this.paymentprocess = true;
      this.number = value;
    },

    userEmail: function (value) {
      this.email = value;
      if (this.number !== "" && this.email !== "") {
        this.handleNICASignature();
      }
    },

    showModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },

    handleIMETokenGeneration() {
      // let path = `https://manager.khaanpin.com/apiv2/imepaytoken/`;
      let path = `https://deus.khaanpin.com/appapi/imepaytoken/`;

      const data = {
        cart_id: CartData.getExtCartId(),
      };

      axios.post(path, data).then(
        (response) => {
          if (response.data.error === false) {
            this.handleIMEPayment(response.data.data);
          }
        },
        (error) => {
          console.log("ERROR", error);
        }
      );
    },

    handleIMEPayment(data) {
      let testpath = `https://stg.imepay.com.np:7979/WebCheckout/Checkout`;
      let livepath = `https://payment.imepay.com.np:7979/WebCheckout/Checkout`;

      let params = {
        TokenId: data.token,
        MerchantCode: "KHAANPIN",
        RefId: data.ref_id,
        TranAmount: data.amount,
        Method: "POST",
        // RespUrl: "https://manager.khaanpin.com/apiv2/imepaymentdetails/",
        RespUrl: "https://deus.khaanpin.com/appapi/imepaymentdetails/",

        CancelUrl: "https://deus.khaanpin.com/appapi/imepaymentdetails/",
        // CancelUrl: "https://manager.khaanpin.com/apiv2/imepaymentdetails/",
      };

      let form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", livepath);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);
      form.submit();
    },

    handleEsewaPayment() {
      var path = "https://esewa.com.np/epay/main";
      var totalAmount = JSON.stringify(CartData.getExtCartAmount());
      var params = {
        amt: totalAmount,
        psc: 0,
        pdc: 0,
        txAmt: 0,
        tAmt: totalAmount,
        pid: JSON.stringify(CartData.getExtCartId()),
        scd: "NP-ES-KHAANPIN",
        // su: "https://manager.khaanpin.com/apiv2/esewasu/",
        su: "https://deus.khaanpin.com/appapi/esewasu/",

        // fu: "https://manager.khaanpin.com/apiv2/esewafu/",
        fu: "https://deus.khaanpin.com/appapi/esewafu/",
      };

      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute("action", path);

      for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);

      form.submit();

      CartData.removeExtCartId();
      CartData.removeExtCartAmount();
    },

    handleNICASignature() {
      let totalAmount = JSON.stringify(CartData.getExtCartAmount());
      let refNo = JSON.stringify(CartData.getExtCartId());

      // console.log("TOTAL AMOUNT", totalAmount, "REF NO", refNo);

      let transRefNo = this.generateRandom(20);

      let uu_id = this.generateUUID();

      let signedFieldNames =
        "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payment_method,bill_to_forename,bill_to_surname,bill_to_email,bill_to_phone,bill_to_address_line1,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,auth_trans_ref_no";

      let signature = {
        // access_key: "615ba3b427fe3de4822da91dff75431d", //Khaanpin test
        // access_key: "e8663c52c3ee327a8192611c3f7d7851", //Khaanpin live
        access_key: "d45aa73e04603c2bb6510e1115190720", //Khaanpin live

        profile_id: "29A0A19A-5AD4-4C1A-AC65-EB90AB3E3079", // Khaanpin test
        // profile_id: "43AEFE03-BDAD-4F08-92ED-7DD776C6DA10", // Khaanpin live

        transaction_uuid: uu_id,

        signed_field_names: signedFieldNames,

        unsigned_field_names: "card_type,card_number,card_expiry_date",

        signed_date_time: this.getDate(), //"2017-02-28T14:38:33Z",

        locale: "en",

        transaction_type: "sale",

        reference_number: refNo,

        amount: totalAmount,

        currency: "NPR",

        payment_method: "card",

        //customers details
        bill_to_forename: "N/A",
        bill_to_surname: "N/A",
        bill_to_email: this.email,
        bill_to_phone: this.number,

        bill_to_address_line1: "N/A",
        bill_to_address_city: "N/A",
        bill_to_address_state: "N/A",
        bill_to_address_country: "NP",
        bill_to_address_postal_code: "N/A",

        card_type: "001",
        card_number: "",
        card_expiry_date: "",

        auth_trans_ref_no: transRefNo,
      };

      // console.log("Signature Data:", signature, typeof signature);

      axios
        .post(
          "https://manager.khaanpin.com/apiv2/getcybersignature/",
          signature
        )
        .then((response) => {
          if (response.data.error === true) {
            console.log("Process Failed", response.data);
          } else {
            this.handleNICAPayment(response.data.data);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    handleNICAPayment(response) {
      let totalAmount = JSON.stringify(CartData.getExtCartAmount());
      let refNumber = JSON.stringify(CartData.getExtCartId());

      const headers = {
        "Content-Type": "application/json",
      };

      let signedFieldNames =
        "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payment_method,bill_to_forename,bill_to_surname,bill_to_email,bill_to_phone,bill_to_address_line1,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,auth_trans_ref_no";

      let payment = {
        // access_key: "615ba3b427fe3de4822da91dff75431d", //Khaanpin test
        // access_key: "e8663c52c3ee327a8192611c3f7d7851", //Khaanpin live
        access_key: "d45aa73e04603c2bb6510e1115190720", //Khaanpin live


        profile_id: "29A0A19A-5AD4-4C1A-AC65-EB90AB3E3079", // Khaanpin test
        // profile_id: "43AEFE03-BDAD-4F08-92ED-7DD776C6DA10", // Khaanpin live

        // transaction_uuid: "edf22984-5f1e-4f35-b793-c8a6b0ac36f0",
        transaction_uuid: response.transaction_uuid,
        // transaction_uuid: uu_id,

        signed_field_names: signedFieldNames,

        unsigned_field_names: "card_type,card_number,card_expiry_date",

        signed_date_time: response.datetime,

        locale: "en",

        transaction_type: "sale",

        reference_number: refNumber,

        amount: totalAmount,

        currency: "NPR",

        payment_method: "card",

        //customers details

        bill_to_forename: "N/A",
        bill_to_surname: "N/A",
        bill_to_email: this.email,
        bill_to_phone: this.number,

        bill_to_address_line1: "N/A",
        bill_to_address_city: "N/A",
        bill_to_address_state: "N/A",
        bill_to_address_country: "NP",
        bill_to_address_postal_code: "N/A",

        auth_trans_ref_no: response.auth_trans_ref_no,

        signature: response.hmac,

        card_type: "001",
        card_number: "",
        card_expiry_date: "",
      };

      // console.log("Payment Data:", payment, typeof payment);

      var form = document.createElement("form");
      form.setAttribute("method", "POST");
      form.setAttribute(
        "action",
        "https://secureacceptance.cybersource.com/pay"
      );
      form.setAttribute("headers", headers);

      for (var key in payment) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", payment[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);

      form.submit();

      CartData.removeExtCartId();
      CartData.removeExtCartAmount();
    },

    generateRandom(length) {
      let orderID = JSON.stringify(CartData.getExtCartId());
      let result = "";
      let characters = "0123456789";
      let charactersLength = characters.length;
      let idLength = length - orderID.length;
      for (var i = 0; i < idLength; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      let concatStr = orderID.concat(result);
      return concatStr;
    },

    generateUUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-bxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      // console.log("UUID is", uuid);
      return uuid;
    },

    getDate() {
      var date = new Date();
      var current_time =
        date.getUTCFullYear() +
        "-" +
        this.appendZero(date.getUTCMonth() + 1) +
        "-" +
        this.appendZero(date.getUTCDate()) +
        "T" +
        this.appendZero(date.getUTCHours()) +
        ":" +
        this.appendZero(date.getUTCMinutes()) +
        ":" +
        this.appendZero(date.getUTCSeconds()) +
        "Z";
      // console.log("Current time is", current_time, typeof current_time);
      return current_time;
    },

    appendZero(digit) {
      if (digit < 10) {
        return "0" + digit;
      } else {
        return digit;
      }
    },

    // Fonepay Payment Methods
    getFonepayDate() {
      const date = format(new Date(), "MM/dd/yyyy");
      return date;
    },

    generateNewOrderID() {
      const orderID = JSON.stringify(CartData.getExtCartId());
      const randomNo = Math.floor(Math.random() * 9000) + 1000;
      const newOrderID = orderID + "-" + randomNo;
      return newOrderID;
    },

    startFonepayPayment() {
      router.replace("/p/fonepaypaymentext");
    },

    createFonePaySignature() {
      let totalAmount = JSON.stringify(CartData.getExtCartAmount());
      let refNo = this.generateNewOrderID();

      let signature = {
        PID: "PEKV", // merchant code
        MD: "P", // transaction mode (maybe)
        PRN: refNo, // product reference number
        AMT: totalAmount, // bill amount
        CRN: "NPR", // nepalese rupees
        DT: this.getFonepayDate(), // date
        R1: refNo, // remarks 1
        R2: "N/A", // remarks 2
        // RU: "https://manager.khaanpin.com/apiv2/fonepayru", // return url
        RU: "https://deus.khaanpin.com/appapi/fonepayru", // return url
      };

      axios
        .post(
          "https://deus.khaanpin.com/appapi/getfonepaysignature/",
          signature
        )
        .then((response) => {
          if (response.data.error === true) {
            console.log("Process Failed", response.data);
          } else {
            this.handleFonepayPayment(response.data.data);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    handleFonepayPayment(data) {
      let totalAmount = JSON.stringify(CartData.getExtCartAmount());

      // const path = "https://dev-clientapi.fonepay.com/api/merchantRequest";
      const path = "https://clientapi.fonepay.com/api/merchantRequest";

      const params = {
        PID: "PEKV", // merchant code
        MD: "P", // transaction mode (maybe)
        PRN: data.prn, // product reference number
        AMT: totalAmount, // bill amount
        CRN: "NPR", // nepalese rupees
        DT: data.dt, // date
        R1: data.prn, // remarks 1
        R2: "N/A", //remarks 2
        // RU: "https://manager.khaanpin.com/apiv2/fonepayru", // return url
        RU: "https://deus.khaanpin.com/appapi/fonepayru", // return url

        DV: data.hmac,
      };

      const form = document.createElement("form");

      form.setAttribute("method", "GET");
      form.setAttribute("action", path);

      for (let key in params) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }

      document.body.appendChild(form);

      form.submit();

      CartData.removeExtCartId();
      CartData.removeExtCartAmount();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.menu {
  margin-bottom: 6%;
}

.custom-button-wrap {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  align-items: center;
  margin: 5px;
  height: auto;

  .custom-button {
    height: 50px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 5px;

    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        color: white;
      }
    }
    &.black {
      background: white;
      color: black;
      border-color: #60b246;
    }
    &.hide {
      display: none;
    }
  }
}

.client_image {
  height: auto;
  width: 90px;
}

.sub-header {
  font-size: 22px;
  text-align: center;
  color: $brand-color;
  font-weight: 400;
  font-family: $main-font;
  margin-top: 30px;
}

.loading {
  font-size: 18px;
  text-align: center;
  color: $brand-color;
  font-family: $main-font;
  margin-top: 30px;
}

.amount-text {
  font-family: $main-font;
  font-size: 28px;
  margin-top: 10px;
  text-align: center;
  color: #27272f;
}

.amount {
  font-size: 22px;
  text-align: center;
  color: $brand-color;
  font-weight: 400;
  font-family: $main-font;
  margin-top: 30px;
}

.cartid-text {
  font-size: 22px;
  text-align: center;
  font-weight: 400;
  font-family: $main-font;
  margin-top: 30px;
  color: $brand-color;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.id-text {
  color: #27272f;
  margin-left: 10px;
}
</style>
